export const isValidPhoneNumber = (mobile = "") => {
  const regex = new RegExp("^(0)?9\\d{9}$");
  return regex.test(mobile);
};

export const hasDigit = (password = "") => {
  const regex = new RegExp("(?=.*[0-9])");
  return regex.test(password);
};

export const hasLowercase = (password = "") => {
  const regex = new RegExp("(.*[a-z])");
  return regex.test(password);
};

export const hasUppercase = (password = "") => {
  const regex = new RegExp("(.*[A-Z])");
  return regex.test(password);
};

export const hasOneSpecialChar = (password = "") => {
  const regex = new RegExp("[ !#$%&'()*+,-./:;<=>?@[\\]^_`{|}~]");
  return regex.test(password);
};

export const hasMoreThanEightChar = (password = "") => {
  const regex = new RegExp("(.{8,})");
  return regex.test(password);
};

export const hasRtlCharacter = (password = "") => {
  const regex = new RegExp(
    "[\u0600-\u06FF\u0750-\u077F\u0590-\u05FF\uFE70-\uFEFF]"
  );
  return regex.test(password);
};

export const hasEnglishCharacter = (password = "") => {
  const regex = new RegExp("[a-zA-Z0-9]");
  return regex.test(password);
};

export const onlyHasPersianChar = (text = "") => {
  const regex = new RegExp("^[\\u200cآ-ی ء چ]+$");
  return regex.test(text);
};

export const isValidEmail = (email = "") => {
  const regex = new RegExp(
    "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$"
  );
  return regex.test(email);
};

export const isPasswordValid = (password = "") => {
  return (
    !hasRtlCharacter(password) &&
    hasEnglishCharacter(password) &&
    hasMoreThanEightChar(password) &&
    hasLowercase(password) &&
    hasUppercase(password) &&
    hasDigit(password) &&
    hasOneSpecialChar(password)
  );
};

export function isNationalIdValid(nationalId) {
  // STEP 0: Validate national Id

  // Check length is 10
  if (nationalId.length < 10) {
    return false;
  }

  // Check if all of the numbers are the same
  if (
    nationalId == "0000000000" ||
    nationalId == "1111111111" ||
    nationalId == "2222222222" ||
    nationalId == "3333333333" ||
    nationalId == "4444444444" ||
    nationalId == "5555555555" ||
    nationalId == "6666666666" ||
    nationalId == "7777777777" ||
    nationalId == "8888888888" ||
    nationalId == "9999999999"
  ) {
    return false;
  }

  // STEP 00 : if nationalId.lenght==8 add two zero on the left
  if (nationalId.length < 10) {
    let zeroNeeded = 10 - nationalId.length;

    let zeroString = "";
    if (zeroNeeded == 2) {
      zeroString = "00";
    } else {
      zeroString = "0";
    }

    nationalId = zeroString.concat(nationalId);
  }

  // STEP 1: Sum all numbers
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += nationalId.charAt(i) * (10 - i);
  }

  // STEP 2: MOD ON 11
  let mod = sum % 11;

  // STEP 3: Check with 2
  let finalValue;
  if (mod >= 2) {
    finalValue = 11 - mod;
  } else {
    finalValue = mod;
  }

  // STEP 4: Final Step check with control value
  if (finalValue == nationalId.charAt(9)) {
    return true;
  } else {
    return false;
  }
}
